module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "file_033"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0018-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "file_033"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Near Naval Air Station San Diego, a trio of Grumman F2F-1 fighters assigned to VF-2 demonstrates a razzle-dazzle formation. In large groups, the odd positioning of the aircraft gave the formation a confusing, chaotic appearance. This image was taken on July 7, 1937. "), _c('em', [_vm._v("Grumman History Center")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ee272ab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_033.vue
// module id = 150
// module chunks = 0